<div >
    <a class="btn btn-link btn-icon btn-icon--left btn-back hidden"
       [routerLink]="(clinicId) ? ['/clinics'] : ['/home']">
        {{ 'back' | translate }}
    </a>
    <app-breadcrumb
            [firstNode]="{label: 'Users list', 'url': '/home'}">
    </app-breadcrumb>
    <div class="box-shadow">
        <div class="card card--box">
            <div class="card--box__header">
                <div class="card--box__header--info">
                    <div class="card--box__header__title help-btn">
                        <h2>
                            {{ 'Support-Center' | translate }}
                        </h2>
                    </div>
                </div>
            </div>
        </div>

        <div class="table--grid">
            <div class="table--grid__header">
                <div class="table--grid__header-tab" [routerLink]="['/support/videos']">
                    {{ 'Video' | translate }}
                </div>
                <div class="table--grid__header-tab" [routerLink]="['/support/pdfs']">
                    {{ 'PDF' | translate }}
                </div>
                <div class="table--grid__header-tab active">
                    {{ 'Additional information' | translate }}
                </div>
                <div class="table--grid__header-tab" [routerLink]="['/support/release-note']">
                    {{ 'Release Notes' | translate }}
                </div>
            </div>
        </div>

        <div class="basic-information">
            <div class="row">
                <div class="col-xs-8 col-lg-8">
                    <div class="row">
                        <div class="col-xs-12">
                            <span>
                            </span>
                        </div>
                    </div>
                </div>
                <div class="col-xs-4">
                    <ul class="list-inline languages">
                        <ng-container *ngFor="let lang of languages">
                            <li class="list-inline-item" [class.active]="language=== lang['code']" (click)="selectInformationBylanguage(lang['code'])">
                                <a title="{{ 'Click here to show by ' + lang['name'] | translate }}">
                                    <img src="{{ '/assets/icon/flags/'  + lang['code'].toLowerCase() + '.png' }}" alt="{{ lang['name'] }}">
                                </a>
                            </li>
                        </ng-container>
                    </ul>
                </div>
            </div>

            <div class="row">
                    <form [formGroup]="form" novalidate (ngSubmit)="submit(form.value, form.valid)">
                        <div *ngIf="successMessage" class="row form-group" role="alert">
                            <div class="col-sm-12">
                                <div class="alert alert-info">
                                    {{ successMessage | translate }}
                                </div>
                            </div>
                        </div>
                        <div *ngIf="errorMessage.length > 0" class="row form-group" role="alert">
                            <div class="col-sm-10">
                                <div class="alert alert-danger">
                                    <div *ngFor="let error of errorMessage">
                                        <i class="fas fa-exclamation-circle" aria-hidden="true"></i>
                                        {{ error | translate}}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="form-group col-xs-6">
                            <label for="title">{{ 'Support Phone' | translate }} *</label>
                            <input type="text" class="form-control" id="phone" formControlName="support_phone">
                            <small class="form-text text-danger" [hidden]="form.controls.support_phone.valid ||
                                                                               (form.controls.support_phone.pristine &&
                                                                               !formSubmitted)">
                                {{ 'Support Phone is required.' | translate }}
                            </small>
                        </div>

                        <div class="form-group col-xs-6">
                            <label for="title">{{ 'Support Email' | translate }} *</label>
                            <input type="text" class="form-control" id="email" formControlName="support_email">
                            <small class="form-text text-danger" [hidden]="form.controls.support_email.valid ||
                                                                               (form.controls.support_email.pristine &&
                                                                               !formSubmitted)">
                                {{ 'Support Email is required.' | translate }}
                            </small>
                        </div>

                        <div class="form-group col-xs-12">
                            <label for="title">{{ 'Support Introduction' | translate }}</label>
                            <app-tinymce #pdfDescription formControlName="support_template"
                                         id="content"
                                         [options]="
                                                    {
                                                    menubar: false,
                                                    toolbar: 'bold italic alignleft numlist bullist link formatselect | removeformat'
                                                    }"
                            ></app-tinymce>
                            <br>
                        </div>

                        <div class="col-xs-12 text-xs-right">
                            <button type="submit" class="btn btn-primary">
                                <span>{{ 'Save' | translate }}</span>
                            </button>
                        </div>
                    </form>
                </div>

        </div>
    </div>
</div>
<router-outlet></router-outlet>


